import * as React from 'react';
import { imageUrl, noImageUrl } from '../../config';
import { addWebpSuffixIfSupported } from '../../utils/webP';

interface IImageProps {
  image: GQL.IImage | string | null;
  width?: number;
  height?: number;
  className?: string;
  alt?: string;
  style?: any;
  onClick?: () => void;
  onLoad?: () => void;
}

interface IImageUrlProps {
  image: GQL.IImage | string | null;
  width?: number;
  height?: number;
}

class Image extends React.Component<IImageProps> {

  public static createUrlImage(props: IImageUrlProps) {
    const { image, width, height } = props;
    
    let imgUrl = noImageUrl;
    if (image) {
      // image je object GQL.IImage
      if (typeof image !== 'string' && image.file) {
        imgUrl = image.file;
      }
      // image je string (url obrázku)
      if (typeof image === 'string') {
        imgUrl = image;
      }
      
      // resize
      if (width && height) {
        imgUrl = imgUrl.substr(0, imgUrl.lastIndexOf('.'))
          + `_${width}x${height}.`
          + imgUrl.substr(imgUrl.lastIndexOf('.') + 1);
      }

      imgUrl = imageUrl + imgUrl;
    }

    return imgUrl;
  }

  render() {
    const { image, width, height, className, alt, style } = this.props;

    const imgUrl = Image.createUrlImage({ image, width, height });

    return (
      <img
        src={addWebpSuffixIfSupported(imgUrl)}
        className={className}
        alt={alt}
        style={style}
        onClick={this.props.onClick}
        onError={(e: any) => {
          e.target.onerror = null;
          e.target.src = noImageUrl;
        }}
        onLoad={(e) => this.props.onLoad && this.props.onLoad()}
      />
    );
  }
}

export default Image;



// WEBPACK FOOTER //
// ./src/components/Image/Image.tsx